export default __webpack_public_path__ + "static/media/Ass 1.5b426913.png";